import type { InfiniteData } from '@tanstack/react-query';

import type { VehicleListItem } from 'Types/vehicle';

import type { VehicleListFetcher } from '../useFetchVehicleList/useFetchVehicleList.types';

export interface GetVehiclesCount {
	selectedVehicle?: VehicleListItem;
	vehicles?: InfiniteData<VehicleListFetcher>;
}

export const getVehiclesCount = ({ selectedVehicle, vehicles }: GetVehiclesCount): number => {
	if (!vehicles || !vehicles.pages) {
		return selectedVehicle ? 1 : 0;
	}

	const lastPage = vehicles.pages.length - 1;
	const vehiclesCount = vehicles.pages[lastPage]?.data?.totalCount || 0;
	const selectedVehicleCount = selectedVehicle ? 1 : 0;
	return vehiclesCount + selectedVehicleCount;
};
